

























































import { defineComponent, PropType, ref } from '@vue/composition-api';
import { ITableOptions } from '@/bundles/BaseTable/interfaces';
import { IAdClient } from '@/bundles/Ad/interfaces';
import { useTable } from '@/bundles/BaseTable/composables/useTable';
import { adClientHeadersData } from '@/bundles/Ad/helpers';
import { useAdClient } from '@/bundles/Ad/composables/useAdClient';

import BaseTable from '@/bundles/BaseTable/components/BaseTable.vue';
import AdClientEditForm from '@/bundles/Ad/components/AdClientEditForm.vue';

export default defineComponent({
  name: 'AdClientsListTable',

  components: {
    BaseTable,
    AdClientEditForm,
  },

  emits: ['options:change', 'items:refresh'],

  props: {
    tableOptionsEntry: {
      type: Object as PropType<ITableOptions>,
      required: true
    },
    itemsEntry: {
      type: Array as PropType<IAdClient[]>,
    },
    totalRowsEntry: {
      type: Number,
      default: 0
    },
    loading: Boolean,
  },

  setup (_, { emit }) {
    const { editLoading, editClient, adClient } = useAdClient();
    const { calculateHeight } = useTable();
    function optionsChangeEventHandler (options: ITableOptions) {
      emit('options:change', options);
    }

    async function archiveEventHandler (item: IAdClient) {
      confirm('Are you sure?') && await (async function () {
        await editClient(item.id, { name: item.name, active: false });
        emit('items:refresh');
      })();
    }

    const showEditForm = ref(false);
    function openEditDialog (item: IAdClient) {
      adClient.value = item;
      showEditForm.value = true;
    }

    return {
      editLoading,
      adClientHeadersData,
      showEditForm,
      adClient,
      calculateHeight,
      openEditDialog,
      optionsChangeEventHandler,
      archiveEventHandler,
    };
  },
});
